// extracted by mini-css-extract-plugin
export var $animation_name = "Product-module--$animation_name--3d029";
export var GalleryScroll = "Product-module--GalleryScroll--0ea8c";